import { storage } from '@/services/firebase'

export const saveFile = async (file, path, name = undefined) => {
    try {
        const storageRef = storage().ref(path)
        const docRef = storageRef.child(name ? name : file.name)
        let metadata = {
            customMetadata: {
                filename: file.name,
            },
        }
        await docRef.put(file, metadata)
    } catch (error) {
        throw new Error('FILE ERROR!')
    }
}
